// @flow
import React from "react";
import tvgConf from "@tvg/conf";
import type { Children } from "@tvg/types/Generic";
import type { TabItem } from "@tvg/types/Common";
import TabGroup from "../../_molecule/TabGroup";
import { Header, PCContainer, TabContainer, Title } from "./styled-components";

type Props = {
  children: Children,
  tabs: Array<TabItem>,
  hasAlert: boolean
};

const PreferencesCenter = ({ tabs, hasAlert, children }: Props) => {
  const renderTabs = () => {
    return <TabGroup tabs={tabs} stretch={tvgConf().device !== "desktop"} />;
  };

  return (
    <React.Fragment>
      {tvgConf().device === "desktop" && (
        <Header data-qa-label="preferences-header">
          <Title data-qa-label="preferences-header-title">Preferences</Title>
          {renderTabs()}
        </Header>
      )}
      <PCContainer>
        {tvgConf().device !== "desktop" && renderTabs()}
        <TabContainer
          data-qa-label="tab-children-container"
          $isDesktop={tvgConf().device === "desktop"}
          $hasAlert={hasAlert}
        >
          {children}
        </TabContainer>
      </PCContainer>
    </React.Fragment>
  );
};

export default PreferencesCenter;
